<section class="company-list" *appHasPermission="customerPermissions.MODULE">
  <div class="company__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="company__header__map d-none">
      <i class="pi pi-map"></i>
    </div>
  </div>
  <div class="company__header">
    <div class="company__header__title">
      <h1>{{ tk.Management.Companys | t }}</h1>
    </div>
    <div class="company__header__search">
      <div class="form-search d-none d-md-flex">
        <app-search
          [isLoading]="isLoading"
          [placeholder]="(tk.General.Search | t) || ''"
          (sendSearch)="handleSearch($event)"></app-search>
      </div>
      <app-select
        class="company__header__status"
        [theme]="'medium'"
        [hasFilter]="false"
        [options]="commercialStatusOptions"
        [ngModel]="commercialStatus"
        (ngModelChange)="handleCommercialStatusChange($event)" />
      <!-- PBI 3576: origem do cadastro (só as empresas que o Cog cadastrou a partir do Data Room). -->
      <ng-container *appHasPermission="autoRegistrationPermissions.VIEW">
        <app-select
          class="company__header__status"
          [theme]="'medium'"
          [hasFilter]="false"
          [options]="registrationSourceOptions"
          [ngModel]="registrationSource"
          (ngModelChange)="handleRegistrationSourceChange($event)" />
      </ng-container>
      <!-- Card 3642: setor padronizado. -->
      <ng-container *appHasPermission="companySectorPermissions.LIST">
        <app-company-sector-filter
          class="company__header__status"
          (sectorChange)="handleSectorFilterChange($event)" />
      </ng-container>
      <ng-container *appHasPermission="economicGroupPermissions.LIST">
        <app-button
          [icon]="'pi pi-sitemap'"
          [label]="'Grupos Econômicos'"
          [type]="'button'"
          [theme]="'dashed'"
          (sendButtonClick)="goToEconomicGroups()"></app-button>
      </ng-container>
      <ng-container *appHasPermission="customerPermissions.CREATE">
        <app-button
          *ngIf="companys.length"
          [id]="'add-group'"
          [label]="isMobile ? '' : (tk.User.ToAdd | t)"
          [icon]="'pi pi-plus'"
          [type]="'button'"
          (sendButtonClick)="addCompany()"></app-button>
      </ng-container>
    </div>
  </div>
  <div class="company__content">
    <app-company-list-content
      #list
      [groupList]="companys"
      [loaded]="companiesLoaded"
      [pagination]="pagination"
      [selectable]="canAssignSector"
      (selectionChange)="handleCompanySelection($event)"
      (sendTablePagination)="handleTablePagination($event)"
      (sendTableAction)="handleTableAction($event)"></app-company-list-content>
  </div>
</section>

<app-modal-business-case-upload
  #businessCaseModal
  (uploadCompleted)="onBusinessCaseUploadCompleted()">
</app-modal-business-case-upload>

<app-billing-parameters-dialog
  #billingParametersDialog
  [level]="'company'"
  (configurationSaved)="onSettingsUpdated()"
  (dialogClosed)="onBillingDialogClosed()"
  (loadingComplete)="onBillingDialogLoadingComplete()">
</app-billing-parameters-dialog>

<app-transfer-company-modal #transferCompanyModal (transferCompleted)="onTransferCompleted()">
</app-transfer-company-modal>

<!-- Card 3642: troca de setor em lote das empresas marcadas. -->
@if (canAssignSector) {
  <app-company-sector-bulk-actions
    [companies]="selectedCompanies"
    (cleared)="clearCompanySelection()"
    (assigned)="onSectorAssigned()" />
}
